import { createUseStyles } from '@pushpay/styles';
export const useStyles = createUseStyles(theme => ({
  backArrow: {
    color: theme.colors['palette-grey-dark-200']
  },
  backButton: {
    borderBottom: `1px solid ${theme.colors['palette-grey-light-200']}`,
    justifyContent: 'flex-start',
    minHeight: '56px',
    padding: theme.SPACING.SMALL,
    '&:focus': {
      backgroundColor: theme.colors['product-color-light-400']
    },
    '&:hover': {
      backgroundColor: theme.colors['product-color-light-400']
    }
  },
  backButtonText: {
    font: theme.TYPOGRAPHY.HEADLINE_3,
    marginLeft: theme.SPACING.SMALL
  }
}));